module.exports = __webpack_public_path__ + "img/ratings_knn.635fd140.png";